import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainApp from './MainApp';
import SurveyPage from './pages/SurveyPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Main authenticated app (Sign in, Sign up, Chat) */}
        <Route path="/*" element={<MainApp />} />

        {/* Public survey chat route */}
        <Route path="/survey/:accessToken" element={<SurveyPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;